import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import { adminApi, formatApiErrorDetail } from "./api";

export default function ChangePassword() {
  const { user, applyToken } = useAdminAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const validate = () => {
    if (next.length < 12) return "New password must be at least 12 characters.";
    if (!/[a-zA-Z]/.test(next)) return "New password must contain at least one letter.";
    if (!/[0-9]/.test(next)) return "New password must contain at least one number.";
    if (next !== confirm) return "New password and confirmation do not match.";
    return "";
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    const localErr = validate();
    if (localErr) {
      setErr(localErr);
      return;
    }
    setBusy(true);
    try {
      const { data } = await adminApi.changePassword(current, next);
      applyToken(data.access_token, false, user?.email);
      nav("/admin", { replace: true });
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Could not change password.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ga-auth" data-testid="admin-change-password-page">
      <div className="ga-auth__card">
        <div className="ga-eyebrow">First sign-in</div>
        <h1 className="ga-auth__title">Set a new password</h1>
        <p className="ga-auth__sub">
          Choose a password of at least 12 characters, with at least one letter and one number.
        </p>
        <form onSubmit={onSubmit} className="ga-form" noValidate>
          <label className="ga-field">
            <span>Current password</span>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              data-testid="pw-current"
            />
          </label>
          <label className="ga-field">
            <span>New password</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              value={next}
              onChange={(e) => setNext(e.target.value)}
              data-testid="pw-new"
            />
          </label>
          <label className="ga-field">
            <span>Confirm new password</span>
            <input
              type="password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              data-testid="pw-confirm"
            />
          </label>
          {err && <div className="ga-error" data-testid="pw-error">{err}</div>}
          <button type="submit" className="ga-btn" disabled={busy} data-testid="pw-submit">
            {busy ? "Updating…" : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
}
